/**
 * « 56,00 € » — deux décimales toujours, virgule décimale et espace insécable
 * avant le symbole, comme sur une facture française.
 */
export function formatEuros(amount: number): string {
  return `${amount.toFixed(2).replace('.', ',')} €`;
}

/**
 * « −158,00 € », « +80,00 € », « 0,00 € » — sur un solde ou un mouvement de relevé,
 * le signe porte le sens : il s'écrit en toutes lettres, avec le vrai signe moins.
 */
export function formatSignedEuros(amount: number): string {
  const sign = amount < 0 ? '−' : amount > 0 ? '+' : '';
  return `${sign}${formatEuros(Math.abs(amount))}`;
}

const WHOLE_EUROS = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });

/**
 * « 1 250 € » — l'euro près, là où la place manque : les pastilles de mois du
 * Rapport. Jamais sur une ligne de rapport ni sur une note, où le centime compte.
 */
export function formatEurosShort(amount: number): string {
  return `${WHOLE_EUROS.format(amount)} €`;
}

/**
 * « 20 % », « 12,5 % » — un taux se lit à la française : virgule décimale, espace
 * insécable avant le signe, et pas de décimale inutile.
 */
export function formatPercent(rate: number): string {
  return `${String(rate).replace('.', ',')} %`;
}
